import * as React from 'react';
import { connect } from 'react-redux';
import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { IJsonQuery } from '../../../../json_query';
import { getTermValue } from '../../../../json_query/reducers/helpers';
import { setTermValue } from '../../../state/advanced/term';
import { Row, InlineParam } from '../markup';

export interface IHasEquipmentProps {
  hasEquipment: boolean | undefined;

  setTerm(key: keyof IJsonQuery, value: boolean): void;
}

class HasEquipment extends React.PureComponent<IHasEquipmentProps> {
  public render() {
    const { hasEquipment, setTerm } = this.props;

    return (
      <Row title="Наличие оборудования">
        <InlineParam>
          <ButtonCheckbox value={hasEquipment === true} onValueChange={setTerm.bind(null, 'has_equipment', true)}>
            С оборудованием
          </ButtonCheckbox>
        </InlineParam>
        <InlineParam>
          <ButtonCheckbox value={hasEquipment === false} onValueChange={setTerm.bind(null, 'has_equipment', false)}>
            Без оборудования
          </ButtonCheckbox>
        </InlineParam>
      </Row>
    );
  }
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const { jsonQuery } = state.filters;

    return {
      hasEquipment: getTermValue('has_equipment')(jsonQuery),
    };
  },
  (dispatch: Dispatch) => ({
    setTerm: (key: keyof IJsonQuery, value: boolean) => {
      dispatch(setTermValue<boolean>(key, value));
    },
  }),
)(HasEquipment);
